import { V2 } from '@eventr/common'
import { DisclosureGroup } from '../common/DisclosureGroup'
import { useBoundStore } from '../state/bound.store'
import { selectorSplitData } from '../state/itineraryState/currentItin.slice'
import { RendererLocator, ScreenType } from './renderers/rendererLocator'
import { ScreenTypeProvider } from './state/screenTypeProvider'
import { publicColour } from './v2Utils'
interface IRendererSplitterProps {
    v2Data?: V2[]
    remove?: string
    screenType?: ScreenType
}
export const RendererSplitter = ({
    remove,
    screenType = 'personal',
}: IRendererSplitterProps) => {
    const { splitSections, categorized } = useBoundStore(selectorSplitData)

    return (
        <ScreenTypeProvider screenType={screenType}>
            {categorized
                ?.filter(
                    (d) =>
                        d?.sectionDisplayName &&
                        d?.data &&
                        d?.data?.length !== 0 &&
                        (!remove || remove !== d.sectionName)
                )
                ?.map((d, i) => (
                    <RendererLocator
                        data={d}
                        screenType={screenType}
                        key={'v2Section' + i}
                        id={screenType + i.toString()}
                    />
                ))}
            {splitSections?.map((pub, i) => {
                return (
                    <DisclosureGroup
                        key={'i' + i}
                        id={pub.name}
                        decourColour={publicColour}
                        childrenHandlePadding
                        stickyHeader={false}
                        borderPosition="underTitle"
                        title={pub.name.toUpperCase()}
                        isOpen={true}
                        content={pub.data?.map((d, j) => (
                            <RendererLocator
                                id={pub.name + j.toString()}
                                data={d}
                                screenType={screenType}
                                isPublic={true}
                                key={'v2Section' + j + i}
                            />
                        ))}
                    />
                )
            })}
        </ScreenTypeProvider>
    )
}
